/* Decorner: cream frosted-fade over the sticky header + cloud puff below.
 * Homepage only. Shows when data-sticky-state="active" on #header-component.
 *
 * SVG mask strategy:
 *  - fade.top = 0, height = headerHeight + 30 (cloud puff zone)
 *  - White fills the header zone; gradient cloud puff fades out below
 *  - Fixed black strips cut through left side (burger) and right side (icons)
 *  - Logo cutout is dynamic (varies by wordmark width)
 */
(function () {
  function init() {
    var main = document.getElementById('MainContent');
    var isHome =
      (main && main.dataset.template === 'index') ||
      (window.Shopify && window.Shopify.template === 'index');
    if (!isHome) return;

    var hdr =
      document.getElementById('header-component') ||
      document.querySelector('header-component');
    if (!hdr) return;

    var cloudPath =
      'M0,26' +
      ' C10,26 16,27 35,27 C54,27 60,26 70,26' +
      ' C95,26 108,28 150,28 C192,28 205,26 230,26' +
      ' C246,26 255,27.5 280,27.5 C305,27.5 314,26 330,26' +
      ' C342,26 348,27 365,27 C382,27 389,26 400,26' +
      ' L400,0 H0 Z';

    var fade = document.createElement('div');
    fade.id = 'dc-header-fade';
    fade.style.cssText = [
      'position:fixed',
      'left:0',
      'right:0',
      'top:0',
      'height:0px',
      'pointer-events:none',
      'z-index:9997',
      'background:rgba(253,251,247,0.18)',
      '-webkit-backdrop-filter:blur(2px) brightness(1.04)',
      'backdrop-filter:blur(2px) brightness(1.04)',
      'opacity:0',
      'transition:opacity .3s ease'
    ].join(';');
    document.body.appendChild(fade);

    // ── Drawer detection ────────────────────────────────────────────────────
    function isAnyDrawerOpen() {
      // Body/html scroll-lock
      var b = document.body, h = document.documentElement;
      if (b.style.overflow === 'hidden' ||
          b.classList.contains('overflow-hidden') ||
          b.classList.contains('scroll-lock') ||
          h.classList.contains('overflow-hidden') ||
          h.classList.contains('scroll-lock')) return true;

      // Any open <details> in the header (hamburger, search, etc.)
      if (document.querySelectorAll('#header-component details[open]').length > 0) return true;

      // Position-based cart check — targets the actual sliding panel only.
      // NOTE: the loose selector this used to have ('[id*="cart-drawer"]',
      // '[class*="cart-drawer"]') matched #shopify-section-cart-drawer-section
      // first -- the outer Section-Rendering-API wrapper, which is always
      // left:0 and full-width even while the drawer is closed (it's just a
      // zero-height container). That made this check permanently return
      // true, which permanently held the header fade at opacity 0.
      // The real panel is theme-drawer#cart-drawer > .cart-drawer__inner --
      // queried explicitly (not combined into one selector) because
      // theme-drawer itself is `display: contents` and always reports a
      // 0x0 rect, so a combined selector picking the outer element first
      // (document order) would silently never trigger either.
      var vw = window.innerWidth;
      var cartEl = document.querySelector('.cart-drawer__inner') ||
        document.querySelector('theme-drawer#cart-drawer');
      if (cartEl) {
        var r = cartEl.getBoundingClientRect();
        if (r.width > 50 && r.left < vw) return true;
      }

      return false;
    }

    // ── Per-element rect cutout helper ──────────────────────────────────────
    function elRect(el, scaleX, pad) {
      var r = el.getBoundingClientRect();
      if (r.width < 2 || r.height < 2) return '';
      var x = Math.max(0, (r.left - pad) * scaleX).toFixed(1);
      var y = Math.max(0, r.top  - pad).toFixed(1);
      var w = ((r.width  + pad * 2) * scaleX).toFixed(1);
      var h = (r.height  + pad * 2).toFixed(1);
      return '<rect x="' + x + '" y="' + y + '" width="' + w + '" height="' + h + '" rx="3" fill="black"/>';
    }

    // ── Build SVG mask ──────────────────────────────────────────────────────
    function buildMask(hdrH) {
      var totalH = hdrH + 30;
      var vw = window.innerWidth || 400;
      var scaleX = 400 / vw;

      // Left side — fixed strip covering burger icon area (lazy square)
      var lw = (90 * scaleX).toFixed(1);
      var leftCut = '<rect x="0" y="0" width="' + lw + '" height="' + hdrH + '" fill="black"/>';

      // Right side — individual rect per icon (search, cart, account)
      var rightCuts = '';
      var seen = {};
      var rightSels = [
        '#header-component .header-actions__action',
        '#header-component .account-button',
        '#header-component shopify-account'
      ];
      rightSels.forEach(function (sel) {
        document.querySelectorAll(sel).forEach(function (el) {
          var r = el.getBoundingClientRect();
          if (r.width < 2 || r.height < 2) return;
          var key = Math.round(r.left) + ',' + Math.round(r.top);
          if (seen[key]) return;
          seen[key] = true;
          rightCuts += elRect(el, scaleX, 4);
        });
      });

      // Logo cutout (dynamic — wordmark width varies)
      var logoCut = '';
      var logoEl = document.querySelector(
        '#header-component .header-logo, #header-component .header__heading-logo'
      );
      if (logoEl) logoCut = elRect(logoEl, scaleX, 10);

      var cutouts = leftCut + rightCuts + logoCut;

      var svg = [
        '<svg xmlns="http://www.w3.org/2000/svg"',
        ' viewBox="0 0 400 ' + totalH + '" preserveAspectRatio="none">',
        '<defs>',
        '<linearGradient id="gH" x1="0" x2="0" y1="0" y2="1">',
        '<stop offset="0%" stop-color="white"/>',
        '<stop offset="100%" stop-color="white"/>',
        '</linearGradient>',
        '<linearGradient id="gC" x1="0" x2="0" y1="0" y2="1">',
        '<stop offset="0%" stop-color="white"/>',
        '<stop offset="50%" stop-color="white"/>',
        '<stop offset="80%" stop-color="white" stop-opacity=".3"/>',
        '<stop offset="100%" stop-color="white" stop-opacity="0"/>',
        '</linearGradient>',
        '<mask id="m">',
        '<rect x="0" y="0" width="400" height="' + hdrH + '" fill="url(#gH)"/>',
        '<path transform="translate(0,' + hdrH + ')" fill="url(#gC)" d="' + cloudPath + '"/>',
        cutouts,
        '</mask>',
        '</defs>',
        '<rect x="0" y="0" width="400" height="' + totalH + '" fill="white" mask="url(#m)"/>',
        '</svg>'
      ].join('');

      return { svg: svg, totalH: totalH };
    }

    // ── Update ──────────────────────────────────────────────────────────────
    var rafId = null;

    // The frosted fade is only meant for the initial, unscrolled view (it
    // blends the transparent header into the very top of the hero photo).
    // The moment the shopper scrolls at all, it should disappear and the
    // header should fall back to its normal plain solid background --
    // letting it linger for any part of the scroll (even still over the
    // hero image) reads as a stray hazy bar sitting on top of the photo.
    function isAtTop() {
      var y = window.scrollY || document.documentElement.scrollTop ||
        (document.querySelector('.page-wrapper') || {}).scrollTop || 0;
      return y < 4;
    }

    // Horizon's own sticky-header background (.header__underlay-closed) is
    // permanently semi-transparent + blurred ("frosted glass") by theme
    // default -- that's the actual source of the hazy look bleeding through
    // for the ENTIRE rest of the scroll, independent of the custom fade div
    // above. Force it fully opaque/unblurred as soon as we're not at the
    // top, so only our own tuned fade (with its logo/icon cutouts) ever
    // shows the frosted look, and only for that initial top view.
    var underlay = document.querySelector('.header__underlay-closed');
    function setUnderlaySolid(makeSolid) {
      if (!underlay) return;
      // Horizon's base CSS sets this background-color with !important, which
      // beats a plain inline style -- setProperty(..., 'important') is
      // required to actually win the cascade here.
      if (makeSolid) {
        underlay.style.setProperty('background-color', '#FDFBF7', 'important');
        underlay.style.setProperty('backdrop-filter', 'none', 'important');
        underlay.style.setProperty('-webkit-backdrop-filter', 'none', 'important');
      } else {
        underlay.style.removeProperty('background-color');
        underlay.style.removeProperty('backdrop-filter');
        underlay.style.removeProperty('-webkit-backdrop-filter');
      }
    }

    function update() {
      rafId = null;
      var stickyActive = hdr.dataset.stickyState === 'active';
      var atTop = isAtTop();
      setUnderlaySolid(stickyActive && !atTop);
      var solid = stickyActive && atTop;
      if (solid && !isAnyDrawerOpen()) {
        var hdrH = Math.round(hdr.getBoundingClientRect().height);
        if (hdrH <= 0) { fade.style.opacity = '0'; return; }
        var mask = buildMask(hdrH);
        var svgUrl = 'url("data:image/svg+xml;charset=utf-8,' +
          encodeURIComponent(mask.svg) + '")';
        fade.style.top = '0';
        fade.style.height = mask.totalH + 'px';
        fade.style.webkitMaskImage = svgUrl;
        fade.style.maskImage = svgUrl;
        fade.style.webkitMaskSize = '100% 100%';
        fade.style.maskSize = '100% 100%';
        fade.style.webkitMaskRepeat = 'no-repeat';
        fade.style.maskRepeat = 'no-repeat';
        fade.style.opacity = '1';
      } else {
        fade.style.opacity = '0';
      }
    }

    function requestUpdate() {
      if (rafId === null) rafId = requestAnimationFrame(update);
    }

    // ── Observers ───────────────────────────────────────────────────────────
    new MutationObserver(requestUpdate).observe(hdr, {
      attributes: true, attributeFilter: ['data-sticky-state', 'transparent']
    });
    new MutationObserver(requestUpdate).observe(hdr, {
      subtree: true, attributes: true, attributeFilter: ['open']
    });
    new MutationObserver(requestUpdate).observe(document.body, {
      attributes: true, attributeFilter: ['style', 'class']
    });

    hdr.querySelectorAll('details').forEach(function (d) {
      d.addEventListener('toggle', requestUpdate);
    });

    function observeCartDrawer() {
      // Watch theme-drawer#cart-drawer's own `open` attribute -- confirmed
      // the authoritative, reliable open/close signal Horizon toggles.
      // (.cart-drawer__inner never gets its own attribute changes; it's
      // just sized via a CSS descendant selector off the parent's [open],
      // so observing it here would never fire.)
      var cd = document.querySelector('theme-drawer#cart-drawer');
      if (cd) {
        new MutationObserver(requestUpdate).observe(cd, {
          attributes: true,
          attributeFilter: ['open', 'aria-hidden', 'aria-expanded', 'class', 'style']
        });
        // Catch the end of the slide-in/out CSS transition
        cd.addEventListener('transitionend', requestUpdate);
      }
    }
    observeCartDrawer();
    setTimeout(observeCartDrawer, 1500);

    // Horizon custom events for cart/drawer open/close
    ['cart:open', 'cart:close', 'drawer:open', 'drawer:close',
     'cartDrawer:show', 'cartDrawer:hide'
    ].forEach(function (evtName) {
      document.addEventListener(evtName, requestUpdate);
    });

    var pageWrapper = document.querySelector('.page-wrapper');
    if (pageWrapper) pageWrapper.addEventListener('scroll', requestUpdate, { passive: true });
    document.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate, { passive: true });

    requestUpdate();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
